export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAGCAYAAADzG6+8AAAAFklEQVQokWNUTV70n4EMwESOppGiEQDlcQI1Z4GNywAAAABJRU5ErkJggg=="